// eslint-disable-next-line import/no-anonymous-default-export
export default {
	domain: process.env.REACT_APP_AUTH0_DOMAIN,
	clientID: process.env.REACT_APP_AUTH0_CLIENT_ID,
	redirectURI: process.env.REACT_APP_AUTH0_REDIRECT_URI,
	serverUrl: process.env.REACT_APP_SERVER_URL,
	auth0Organization: process.env.REACT_APP_AUTH0_ORGANIZATION,
	apiUrl: process.env.REACT_APP_API_URL
};
